import { Chip } from '@material-ui/core';
import { green, grey } from '@material-ui/core/colors';

export const LeaseYesNoChip = ({ value }: { value: 'Yes' | 'No' }) => {
  const color = value === 'No' ? green : grey;
  return (
    <Chip
      label={value}
      style={{
        fontWeight: 0,
        backgroundColor: color[200],
        color: color[900],
      }}
    />
  );
};
